<template lang="pug">
  SspLayout(area="core")
    .row.create-metadata-schema
      .col-md-12
        SspSaveForm(@onSubmit="save" :saveDisabled="!isValid" :saving="saving")
          .form-horizontal
            .form-group
              label.col-sm-2.control-label Name
              .col-sm-8
                input.form-control(v-model="name" type="text" placeholder="Metadata Schema Name")
            .form-group
              label.col-sm-2.control-label Schema Definition
              .col-sm-8
                textarea.schema-textarea.form-control(v-model="schema" type="text" placeholder="Metadata Schema")

</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'

export default {
  data: () => ({
    saving: false,
    name: null,
    schema: null
  }),
  methods: {
    save() {
      this.saving = true
      Core.createMetadataSchema(encodeURIComponent(this.name), this.schema)
        .then(() => {
          miniToastr.success('Schema was successfully created!')
          this.$router.push('/core/configuration/metadataschemas')
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  computed: {
    isValid() {
      return this.name && this.schema
    }
  }
}
</script>

<style lang="scss">
.create-metadata-schema {
  .schema-textarea {
    min-height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/metadataschema/CreateMetadataSchema.vue